import { cn as e } from "../../shared/utils.js";
import { forwardRef as t } from "react";
import { jsx as n } from "react/jsx-runtime";
import { Progress as r } from "@base-ui/react/progress";
//#region src/progress/primitive/index.tsx
var i = t((e, t) => /* @__PURE__ */ n(r.Root, {
	ref: t,
	...e
})), a = t(({ className: t, ...i }, a) => /* @__PURE__ */ n(r.Label, {
	ref: a,
	className: e("text-text-primary text-base font-medium", t),
	...i
})), o = t(({ className: t, ...i }, a) => /* @__PURE__ */ n(r.Track, {
	ref: a,
	className: e("bg-bg-tertiary h-1 w-full overflow-hidden rounded-full", t),
	...i
})), s = t(({ className: t, ...i }, a) => /* @__PURE__ */ n(r.Indicator, {
	ref: a,
	className: e("bg-bg-accent-active transition-base h-full rounded-full transition-[width,transform,background-color]", t),
	...i
})), c = t(({ className: t, ...i }, a) => /* @__PURE__ */ n(r.Value, {
	ref: a,
	className: e("text-text-tertiary text-right text-base font-normal", t),
	...i
}));
i.displayName = r.Root.displayName, a.displayName = r.Label.displayName, o.displayName = r.Track.displayName, s.displayName = r.Indicator.displayName, c.displayName = r.Value.displayName;
var l = {
	Root: i,
	Label: a,
	Track: o,
	Indicator: s,
	Value: c
};
//#endregion
export { l as Progress };
